import { FaWhatsapp, FaLinkedin, FaInstagram } from "react-icons/fa";
import { BsTwitterX } from "react-icons/bs";

const ShareButtons = ({ url, title }) => {
  const shareUrl = encodeURIComponent(url);
  const shareTitle = encodeURIComponent(title);

  return (
    <div className="mt-8 border-t border-white">
      <div className="mt-12 flex flex-col items-start justify-start space-y-4">
        {/* Share Text */}
        <span className="text-2xl font-semibold text-purple-700">
          Share this post:
        </span>

        {/* Share Icons */}
        <div className="flex space-x-4">
          {/* WhatsApp */}
          <a
            href={`https://wa.me/?text=${shareTitle}%20${shareUrl}`}
            target="_blank"
            rel="noopener noreferrer"
            className="rounded-full bg-green-500 p-3 text-white transition-colors duration-300 hover:bg-green-600"
            aria-label="Share on WhatsApp"
          >
            <FaWhatsapp />
          </a>

          {/* Twitter */}
          <a
            href={`https://twitter.com/intent/tweet?url=${shareUrl}&text=${shareTitle}`}
            target="_blank"
            rel="noopener noreferrer"
            className="rounded-full bg-blue-500 p-3 text-white transition-colors duration-300 hover:bg-blue-600"
            aria-label="Share on Twitter"
          >
            <BsTwitterX />
          </a>

          {/* LinkedIn */}
          <a
            href={`https://www.linkedin.com/sharing/share-offsite/?url=${shareUrl}`}
            target="_blank"
            rel="noopener noreferrer"
            className="rounded-full bg-blue-700 p-3 text-white transition-colors duration-300 hover:bg-blue-800"
            aria-label="Share on LinkedIn"
          >
            <FaLinkedin />
          </a>

          {/* Instagram */}
          <a
            href={`https://www.instagram.com/?url=${shareUrl}`}
            target="_blank"
            rel="noopener noreferrer"
            className="rounded-full bg-gradient-to-r from-pink-500 to-purple-500 p-3 text-white transition-colors duration-300 hover:from-pink-600 hover:to-purple-600"
            aria-label="Share on Instagram"
          >
            <FaInstagram />
          </a>
        </div>
      </div>
    </div>
  );
};

export default ShareButtons;
